var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupAolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 178 178",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 89,
    fill: "#000",
    r: 89
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.477 99.246a7.511 7.511 0 0 0 -7.523 7.514 7.511 7.511 0 0 0 7.523 7.513 7.511 7.511 0 0 0 7.523-7.513c-.035-4.155-3.397-7.514-7.523-7.514zm-101.786-35.246-19.691 49.927h13.347l2.635-7.202h17.369l2.426 7.202h13.453l-19.485-49.927zm-.208 32.58 5.235-17.415 5.235 17.415zm77.172 17.347h11.301v-49.927h-11.301zm-26.417-38.744c-13.59 0-20.108 10.733-20.108 19.909 0 9.175 6.518 19.908 20.108 19.908s20.107-10.733 20.107-19.908c0-9.21-6.518-19.909-20.107-19.909zm0 29.326c-4.854 0-8.945-3.982-8.945-9.452s4.091-9.452 8.945-9.452c4.853 0 8.944 3.982 8.944 9.452s-4.126 9.452-8.944 9.452z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupAolLogo);
export default __webpack_public_path__ + "static/media/SignupAolLogo.813eb8b1d1d35d62caf8a39f9d6de447.svg";
export { ForwardRef as ReactComponent };